import { AnkleVariabilityData_FunctionalMovement } from '@/models/reportV2.model';

import { themeColors } from '@/theme/colors';

import { flattenData, toGraphData, toVariabilityData } from '.';

/**
 * Retrieves ankle variability data based on the provided parameters.
 * @param data - The data object containing ankle variability data.
 * @param side - The side of the ankle ('Left' or 'Right').
 * @returns An object containing various series data for ankle variability.
 */
export function getAnkleVariabilityData_FunctionalMovement(
  data: any,
  side: 'Left' | 'Right',
): AnkleVariabilityData_FunctionalMovement {
  const overviewColor = side === 'Left' ? themeColors.variabilityAll_Left : themeColors.variabilityAll_Right;
  const crpDataCalfFoot = toGraphData(data[`crpAnkle${side}`][`crpCalfFoot_${side}`]);
  const crpSeriesDataCalfFoot = [
    {
      type: 'line',
      name: 'Calf (s) / Foot (s)',
      data: flattenData(crpDataCalfFoot),
      color: themeColors.colorSS,
    },
  ];

  const crpDataCalfTFootC = toGraphData(data[`crpAnkle${side}`][`crpCalfTFootC_${side}`]);
  const crpSeriesDataCalfTFootC = [
    {
      type: 'line',
      name: 'Calf (t) / Foot (c)',
      data: flattenData(crpDataCalfTFootC),
      color: themeColors.colorTC,
    },
  ];

  const coordinativeVariabilityDataAllAnkle = toVariabilityData(
    data.coordinativeVariability[`coordinativeVariabilityDataAnkle_${side}`].col0,
  );

  const coordinativeVariabilitySeriesAllAnkle = [
    {
      type: 'area',
      name: 'All planes',
      data: coordinativeVariabilityDataAllAnkle,
      color: overviewColor,
    },
  ];

  const coordinativeVariabilityDataCalfFoot = toVariabilityData(
    data.coordinativeVariabilitySquat[`coordinativeVariabilityCalfFoot_${side}`].col0,
  );

  const coordinativeVariabilitySeriesCalfFoot = [
    {
      type: 'area',
      name: 'Calf (s) / Foot (s)',
      data: coordinativeVariabilityDataCalfFoot,
      color: themeColors.colorSS,
    },
  ];

  const coordinativeVariabilityDataCalfTFootC = toVariabilityData(
    data.coordinativeVariabilitySquat[`coordinativeVariabilityCalfFoot_${side}`].col1,
  );

  const coordinativeVariabilitySeriesCalfTFootC = [
    {
      type: 'area',
      name: 'Calf (t) / Foot (c)',
      data: coordinativeVariabilityDataCalfTFootC,
      color: themeColors.colorTC,
    },
  ];

  return {
    crpSeriesDataCalfTFootC,
    crpSeriesDataCalfFoot,
    coordinativeVariabilitySeriesAllAnkle,
    coordinativeVariabilitySeriesCalfFoot,
    coordinativeVariabilitySeriesCalfTFootC,
  };
}
